import {useTheme} from "@mui/material/styles";
import {Box} from "@mui/system";
import {VolumeUpTwoTone} from "@mui/icons-material";
import React from "react";
import {keyframes} from "@emotion/react";


const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.4);
  }
  50% {
    transform: scale(1.3);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0.4);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.4);
  }
`;


const SoundAnimation = () => {
    const theme = useTheme();

    return (
        <Box
            width={50}
            height={50}
            borderRadius="50%"
            sx={{
                backgroundColor: theme.palette.primary.contrastText,
                animation: `${pulseAnimation} 1s infinite`,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <VolumeUpTwoTone  fontSize="large"  />
        </Box>
    );
};


export default SoundAnimation